export default __webpack_public_path__ + "static/media/pedestrian.85cb0d63.svg";